// Source/Linkster/Config.ts
function loadConfig() {
  const script = document.querySelector(`#Linkster`);
  const json = script.textContent;
  const data = JSON.parse(json);
  return data;
}

// Source/Linkster/mod.ts
async function load() {
  const config = loadConfig();
  const accepted = !!CCM.acceptedEmbeddings.find((embed) => embed.name === config.Consent.Name);
  console.debug("Linkster", { accepted });
  if (accepted) {
    const url = new URL(`https://trck.linkster.co/trck/etms/eatms.js`);
    url.searchParams.set("campaign_id", String(config.Campaign.Id));
    loadScript(url.href);
  } else {
    await removeData();
  }
}
function loadScript(url) {
  const script = document.createElement("script");
  script.crossOrigin = "anonymous";
  script.async = true;
  script.src = url;
  document.head.append(script);
}
async function removeData() {
  localStorage.removeItem("linksterid");
  localStorage.removeItem("emid");
  const host = location.hostname;
  const parts = host.split(".");
  const levels = parts.length;
  for (let level = 0;level < levels - 1; level++) {
    const domain = parts.slice(level).join(".");
    await cookieStore.delete({
      domain,
      name: "linksterid"
    });
    await cookieStore.delete({
      domain,
      name: "emid"
    });
  }
}
window.addEventListener("ccm19WidgetClosed", load);
load();
